// extracted by mini-css-extract-plugin
export var leftAlign = "_b-2";
export var popper = "_b-0";
export var subtitle = "_b-1";